import React, { useState } from 'react'
import * as S from './styles'
import { toast } from 'react-toastify'
import { useServices } from 'presentation/hooks/use-services'
import DividerNew from 'presentation/shared/components/DividerNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { ReactComponent as CloseIcon } from 'presentation/assets/icons/close.svg'
import Modal from 'presentation/hospital/components/Modal'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'

import {
  WithLoading,
  WithLoadingProps
} from '../../../shared/components/HOCs/WithLoading'

export type Props = {
  surgicalOrderId: number
  activeStatus?: string
  close: () => void
  setIsLoading: () => void
  filterSubmit: () => void
} & WithLoadingProps

export const ModalChangeStatus = WithLoading(
  ({
    surgicalOrderId,
    activeStatus,
    close,
    setIsLoading,
    filterSubmit
  }: Props) => {
    const orderStatusOptions = [
      { value: 'REVIEW', label: 'Revisão' },
      { value: 'PRE_SCHEDULE', label: 'Pré agendamento' },
      { value: 'OPME_QUOTATION', label: 'Cotação de OPME' },
      { value: 'CRMO', label: 'Na CRMO' },
      { value: 'HEALTH_INSURANCE_APPROVE', label: 'No convênio' },
      { value: 'CRMO_VALIDATION', label: 'Validação CRMO' }
    ]

    const formatedStatusOptions = orderStatusOptions.filter((status: any) => {
      return status.label !== activeStatus
    })

    const [selectedStatus, setSelectedStatus] = useState('')

    const surgicalOrderService = useServices().surgicalOrder

    async function changeOrderStatusModal() {
      try {
        setIsLoading(true)

        const response = await surgicalOrderService.createSurgicalOrderStatus({
          surgical_order_id: surgicalOrderId,
          status: selectedStatus
        })

        if (response.statusCode === 400) {
          return toast.error('Falha na transfêrencia de fase.')
        }

        filterSubmit()

        toast.success('Transferência de fase realizada com sucesso.')
        close()
      } catch (error) {
        toast.error('Falha na transfêrencia de fase.')
      } finally {
        setIsLoading(false)
      }
    }

    return (
      <>
        <Modal close={close}>
          <S.WrapperModal>
            <S.ModalInfo>
              <S.ModalTitle>Transferir de fase</S.ModalTitle>
              <CloseIcon onClick={close} />
            </S.ModalInfo>
            <DividerNew />
            <TextFieldNew
              label="Fase atual do processo"
              placeholder="Médico responsável"
              style={{ maxWidth: '500px' }}
              value={activeStatus}
              disabled
            />

            <SelectFieldNew
              style={{ marginTop: '30px' }}
              label="Nova fase"
              // required={true}
              value={selectedStatus}
              items={formatedStatusOptions}
              onInputChange={(value) => setSelectedStatus(value)}
            />

            <S.StatusButtonPanel>
              <ButtonNew variant="text" onClick={close}>
                Cancelar
              </ButtonNew>

              <ButtonNew
                onClick={changeOrderStatusModal}
                disabled={!selectedStatus}
              >
                Transferir
              </ButtonNew>
            </S.StatusButtonPanel>
          </S.WrapperModal>
        </Modal>
      </>
    )
  }
)
